import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { getConfigs } from 'src/app/core/state/general-state/general.selectors';
import { Stepper } from 'src/app/models/step/step.model';

@Component({
  selector: 'app-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss'],
})
export class StepComponent implements OnInit, OnDestroy {
  @Input('steps') steps: Stepper[] = [];

  configs: any;
  private subscription: Subscription = new Subscription();
  showAdvancedPixSteps: boolean = true;
  visibleStepsCount: number = 0;

  constructor(private store: Store<any>) {
    this.subscription.add(
      this.store.select(getConfigs).subscribe((configs) => {
        if (configs) {
          this.configs = configs;

          this.showAdvancedPixSteps = !(
            configs.pix?.advanced_pix_qrcode_support === false
          );

          this.updateVisibleStepsCount();
        }
      })
    );
  }

  ngOnInit(): void {
    this.updateVisibleStepsCount();
  }

  updateVisibleStepsCount(): void {
    this.visibleStepsCount = 3;

    if (this.showAdvancedPixSteps) {
      this.visibleStepsCount += 2;
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
